<script>
import RequestAgentKitDialog from "@/components/common/requestAgentKitDialog.vue";

export default {
  name: "agentRegistrationSection2",
  data() {
    return {
    };
  },

}
</script>

<template>
  <div class="landing-page">
    <el-row class="container">
      <!-- Header Section -->
      <el-col :span="24" class="header-section">
        <h1 class="main-title">Unlock More Sales with UNIFI Property</h1>
        <p class="subtitle">
          Are you a real estate agent specializing in off-the-plan properties or new developments?
          UNIFI Property is the premier platform to showcase your projects and connect with an
          engaged audience of buyers looking for the latest in new properties.
          Join us to access a streamlined, data-rich environment designed to empower agents
          and simplify the buying journey for your clients.
        </p>
      </el-col>

      <!-- Main Content Section -->
      <el-row class="content-section">
        <!-- Left Column - Image -->
        <el-col :span="24">
          <div class="image-container">
            <img
                src="./../../../assets/agent-section-2-page-background.png"
                alt="UNIFI Property Platform Preview"
                class="feature-image"
            >
          </div>
        </el-col>

        <!-- Right Column - Features -->
        <el-col class="features-column" :span="24">
          <h2 class="features-title">Why Join UNIFI Property?</h2>
          <div class="features-list">
            <div class="feature-item">
              <h3 class="feature-item-title">Targeted Audience :</h3>
              <p class="feature-item-description">Reach buyers who are specifically interested in off-the-plan and newly constructed properties. Our platform is built for those seeking modern living spaces and investment opportunities, increasing the chances of genuine inquiries and faster sales.</p>
            </div>

            <div class="feature-item">
              <h3 class="feature-item-title">Enhanced Listings :</h3>
              <p class="feature-item-description">Showcase your properties with comprehensive listings that include floor plans, development site maps, pricing details, fee breakdowns, and more. Our intuitive layout lets buyers visualize, evaluate, and compare properties effortlessly.</p>
            </div>

            <div class="feature-item">
              <h3 class="feature-item-title">Sell Property While You Sleep :</h3>
              <p class="feature-item-description">Help buyers take the next step with our $1,000 online reservation option. This feature allows buyers to secure properties exclusively for seven days, expediting the sales process while fostering client confidence.</p>
            </div>

            <div class="feature-item">
              <h3 class="feature-item-title">Professional Support & Tools :</h3>
              <p class="feature-item-description">UNIFI Property provides resources tailored to agent needs, from marketing support to dedicated agent dashboards, making it easier to manage your listings and engage with interested buyers effectively.</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>

</template>

<style scoped lang="scss">
.landing-page {
}

.header-section {
  text-align: center;
  padding: 20px 40px;
}

.main-title {
  color: #003333;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.subtitle {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 auto;
}

.content-section {
  margin-top: 40px;
  padding: 40px;
}

.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 300px;
  border-radius: 20px;
  overflow: hidden;
}
.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  overflow: hidden;
}

.features-title {
  display: flex;
  justify-content: center;
  color: #003333;
  font-size: 20px;
  font-weight: 600;
  margin: 30px 0;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.feature-item {
  margin-bottom: 20px;
}

.feature-item-title {
  color: #003333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.feature-item-description {
  color: #003333;
  font-size: 16px;
  font-weight: 200;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .content-section {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationSection2.vue